<template>
    <!-- begin #footer -->
    <div v-if="!appOptions.appEmpty" class="d-block d-sm-none d-md-none">
        <div style="padding-top:80px"></div>
        <div class="
              text-black
              position-fixed
              rounded-0
              position-fixed
              mb-0
              d-md-flex
              align-items-center
           " style="left: 0; right: 0; bottom: 0; z-index: 1020; padding:7px;background-color: #20252a">
            <div class="d-flex flex-row justify-content-between align-items-between ml-1 mr-1" style="width:100%">
                <a class="fa-stack fa-2x text-blue-200" href="#/jobs/ALL">
                    <i class="far fa-square fa-stack-2x"></i>
                    <i class="fas fa-landmark fa-stack-1x "></i>
                </a>

                <a class="fa-stack fa-2x text-blue-200" href="#/tasks/PROGRESS">
                    <i class="far fa-square fa-stack-2x"></i>
                    <i class="fas fa-table-list fa-stack-1x"></i>
                </a>

                <a class="fa-stack fa-2x text-blue-200" href="#/task/create">
                    <i class="far fa-square fa-stack-2x"></i>
                    <i class="fas fa-plus fa-stack-1x "></i>
                </a>

                <a class="fa-stack fa-2x text-blue-200" href="#/referral">
                    <i class="far fa-square fa-stack-2x"></i>
                    <i class="fas  fa-handshake-angle fa-stack-1x "></i>
                </a>

                <a class="fa-stack fa-2x text-blue-200" v-on:click="toggleMobileRightSidebar">
                    <i class="far fa-square fa-stack-2x"></i>
                    <i class="fas fa-user fa-stack-1x"></i>
                </a>
            </div>
        </div>
    </div>
    <!-- end #footer -->
</template>

<script>
    import AppOptions from '../../config/AppOptions.vue'

    export default {
        name: "Footer",
        data() {
            return {
                appOptions: AppOptions,
            };
        },
        methods: {
            toggleMobileRightSidebar() {
                this.appOptions.appSidebarMobileToggled = !this.appOptions.appSidebarMobileToggled;
            },
        },
    };
</script>
